import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { useForm } from "react-hook-form";
import { formatedTelefone } from "./../../../Tools/FormatTools";
import { useWhatsappAtivo } from "./useWhatsappAtivo";
import {
    IEnviarMensagemAtiva,
    IValorVariavel,
    IMensagemTemplate,
} from "../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import { faPhoneSquare } from "@fortawesome/free-solid-svg-icons";
import { ObterValoresVariaveisMensagemAtiva } from "../../../Services/HelpDesk/GestaoAtendimentos/GestaoAtendimentosService";
import ReactInputMask from "react-input-mask";

const MENSAGEM_SELECIONE = "Selecione uma mensagem";
const ESTILO_INVALIDO = "is-invalid";
interface IWhatsappAtivo {
    size?: SizeProp;
    className?: string;
    onClick: () => void;
}
export default function WhatsappAtivo({
    className,
    size,
    onClick,
}: IWhatsappAtivo) {
    return (
        <>
            <OverlayTrigger
                overlay={
                    <Tooltip id="hot-number-tooltip">
                        Enviar Mensagem Whatsapp
                    </Tooltip>
                }
            >
                <FontAwesomeIcon
                    icon={faWhatsapp}
                    size={size}
                    className={`${
                        className || ""
                    } text-muted text-hover-primary font-weight-bold`}
                    onClick={onClick}
                />
            </OverlayTrigger>
        </>
    );
}
interface IInforWhatsappSend {
    lstContatos: Array<string>;
    setModal: React.Dispatch<React.SetStateAction<boolean>>;
}
export function InforWhatsappSend({
    lstContatos,
    setModal,
}: IInforWhatsappSend) {
    const { register, handleSubmit, formState } =
        useForm<IEnviarMensagemAtiva>();
    const [textFormatado, setTextFormatado] = useState<string>("");
    const { SendMessage, lstMessage, inputShow, setInputShow } =
        useWhatsappAtivo({ setModal });
    const [templateValues, setTemplateValues] = useState<IValorVariavel[]>([]);
    const [templateSelecionado, setTemplateSelecionado] =
        useState<IMensagemTemplate | null>(null);
    const [ddiNumDestino, setDdiNumDestino] = useState<string>("+55");
    const [ddiOutro, setDdiOutro] = useState<string>("");
    const [numDestino, setNumDestino] = useState<string>("");

    useEffect(() => {
        if (
            templateValues &&
            templateValues.length > 0 &&
            templateSelecionado
        ) {
            const templatePreenchido = preencherTemplate(
                templateValues,
                templateSelecionado.DS_CORPO_TEMPLATE
            );
            setTextFormatado(templatePreenchido);
        }
    }, [templateValues, templateSelecionado]);
    const preencherTemplate = (valores: IValorVariavel[], template: string) => {
        let templatePreenchido = template;
        valores.forEach((valor) => {
            const regex = `{{${valor.NR_ORDEM}}}`;
            templatePreenchido = templatePreenchido.replace(
                regex,
                valor.DS_VALOR === null ? "" : valor.DS_VALOR
            );
        });
        return templatePreenchido;
    };
    const handleTemplateChange = async (
        e: React.ChangeEvent<HTMLSelectElement>
    ) => {
        const selectedTemplate = lstMessage.find(
            (template) =>
                template.ID_DOCUMENTO_TEMPLATE === parseInt(e.target.value, 10)
        );
        setTemplateSelecionado(selectedTemplate || null);
        if (selectedTemplate) {
            await obterValoresVariaveis(
                numDestino,
                selectedTemplate.ID_DOCUMENTO_TEMPLATE
            );
        }
    };
    const obterValoresVariaveis = async (
        nrCliente: string,
        idTemplate: number
    ) => {
        const response = await ObterValoresVariaveisMensagemAtiva(
            nrCliente,
            idTemplate
        );
        if (response && response.status === 200) {
            setTemplateValues(response.data);
        }
    };

    const onSubmit = (data: IEnviarMensagemAtiva) => {
        let numDestinoFormatado = numDestino;

        // if (ddiNumDestino === "+55" && numDestino.length === 11) {
        //     numDestinoFormatado =
        //         numDestino.substring(0, 2) + numDestino.slice(-8);
        // }

        var ddi = ddiNumDestino !== "outro" ? ddiNumDestino : ddiOutro.replace("_", ""); 
        const mensagemDTO = {
            ddiNumDestino: ddi,
            numDestino: numDestinoFormatado,
            idTemplate: templateSelecionado
                ? templateSelecionado.ID_DOCUMENTO_TEMPLATE
                : 0,
            VariaveisTemplate: templateValues,
        };

        SendMessage(mensagemDTO);
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-group d-flex">
                <select
                    name="ddiNumDestino"
                    className="form-control"
                    value={ddiNumDestino}
                    onChange={(e) => setDdiNumDestino(e.target.value)}
                >
                    <option value="+55">+55 (Brasil)</option>
                    <option value="+1">+1 (EUA)</option>
                    <option value="outro">Outro</option>
                </select>
                {ddiNumDestino === "outro" &&
                    <ReactInputMask
                    type="tel"
                    className={`form-control placeholder-dark-50 ${
                        formState.errors.numDestino && ESTILO_INVALIDO
                    }`}
                    placeholder={"DDI"}
                    max={3}
                    mask={"+999"}
                    onChange={(e) => {
                        setDdiOutro(e.target.value);
                    }}
                />}
                {ddiNumDestino === "+55" ? (
                    inputShow || lstContatos.length === 0 ? (
                        <ReactInputMask
                            name="numDestino"
                            type="tel"
                            className={`form-control placeholder-dark-50 ${
                                formState.errors.numDestino && ESTILO_INVALIDO
                            }`}
                            placeholder={"Digite o número do telefone:"}
                            max={10}
                            mask={"(99) 9 9999-9999"}
                            onChange={(e) => {
                                const numFormatado = e.target.value.replace(
                                    /[^\d]/g,
                                    ""
                                );
                                setNumDestino(numFormatado);
                            }}
                        />
                    ) : (
                        <select
                            name="numDestino"
                            className={`form-control placeholder-dark-50 ${
                                formState.errors.numDestino && "is-invalid"
                            }`}
                            onChange={(e) => {
                                const numFormatado = e.target.value.replace(
                                    /[^\d]/g,
                                    ""
                                );
                                setNumDestino(numFormatado);
                            }}
                            ref={register()}
                        >
                            <option key={0}></option>
                            {lstContatos?.length &&
                                lstContatos.map((contato, index) => {
                                    return (
                                        <option
                                            key={index + 1}
                                            value={formatedTelefone(contato)}
                                        >
                                            {formatedTelefone(contato)}
                                        </option>
                                    );
                                })}
                        </select>
                    )
                ) : (ddiNumDestino === "+1" ? (
                    <ReactInputMask
                        name="numDestino"
                        type="tel"
                        className={`form-control placeholder-dark-50 ${
                            formState.errors.numDestino && ESTILO_INVALIDO
                        }`}
                        placeholder={"Digite o número do telefone:"}
                        max={10}
                        mask={"(999) 999-9999"}
                        onChange={(e) => {
                            const numFormatado = e.target.value.replace(
                                /[^\d]/g,
                                ""
                            );
                            setNumDestino(numFormatado);
                        }}
                    />
                ) : (
                    <input
                        name="numDestino"
                        type="tel"
                        className={`form-control placeholder-dark-50 ${
                            formState.errors.numDestino && ESTILO_INVALIDO
                        }`}
                        placeholder={"Digite o número do telefone:"}
                        max={10}
                        onChange={(e) => {
                            const numFormatado = e.target.value.replace(
                                /[^\d]/g,
                                ""
                            );
                            setNumDestino(numFormatado);
                        }}
                    />
                ))}
                {lstContatos.length > 0 && (
                    <button
                        className="ml-2 btn btn-success btn-block d-flex align-items-center justify-content-center flex-nowrap"
                        style={{
                            width: "5%",
                        }}
                        onClick={() => setInputShow(!inputShow)}
                    >
                        <FontAwesomeIcon
                            icon={faPhoneSquare}
                            size="lg"
                            className=""
                        />
                    </button>
                )}
            </div>
            <div className="form-group">
                <select
                    name="strMensagem"
                    className={`form-control placeholder-dark-50 ${
                        formState.errors.numDestino && ESTILO_INVALIDO
                    }`}
                    ref={register({
                        required: "Selecione uma mensagem",
                        valueAsNumber: false,
                        min: {
                            value: 1,
                            message: "Favor selecione uma mensagem",
                        },
                    })}
                    onChange={(e) => handleTemplateChange(e)}
                >
                    <option key={0} value={0}>
                        {MENSAGEM_SELECIONE}
                    </option>
                    {lstMessage?.length &&
                        lstMessage.map((mensagem: IMensagemTemplate, index) => (
                            <option
                                key={mensagem.ID_DOCUMENTO_TEMPLATE}
                                value={mensagem.ID_DOCUMENTO_TEMPLATE}
                            >
                                {mensagem.DS_CORPO_TEMPLATE}
                            </option>
                        ))}
                </select>
            </div>

            <div className="form-group">
                <textarea
                    className="form-control"
                    name="textMensagem"
                    placeholder="Nenhuma mensagem selecionada"
                    ref={register()}
                    rows={6}
                    value={textFormatado}
                />
            </div>

            <div className="form-group">
                <button className="btn btn-success btn-block d-flex align-items-center justify-content-center flex-nowrap">
                    <FontAwesomeIcon
                        icon={faWhatsapp}
                        size="lg"
                        className="mr-2"
                    />
                    Enviar
                </button>
            </div>
        </form>
    );
}
